import React, {useCallback} from "react";
import {ReportManagement} from "../../components";
import {reports} from "./consts.js";
import {sendAdminReport} from "../../api/report/report.js";

export const AdminReports = () => {
    const onSave = useCallback(async values => {
        const {reportName, params} = values;
        const response = await sendAdminReport(reportName, params);
        return !response?.error;
    }, []);

    return (
        <>
            <ReportManagement reports={reports} onSave={onSave} />
        </>
    );
};
